import React from 'react'
import { Link, useParams } from 'react-router-dom'
import ExcelIcon from '../imgs/excel.gif'
import PdfIcon from '../imgs/pdf.gif'
import {
    PRELIM_SURVEY_LIST_WITHOUT_START_DATE,
    SURVEY_YEAR_NAME_LIST,
    SURVEY_ORG_NUMBER_LIST,
    SURVEY_PUBLISH_DATE_LIST,
    SURVEY_UUID_LIST,
    PRELIM_SURVEY_LIST,
    SURVEY_OLDEST_SUBMISSION_DATE,
    SURVEY_MOST_RECENT_SUBMISSION_DATE,
    SURVEY_YEAR_FOR_LAST_AVAILABLE_HISTORICAL_YEAR,
    SURVEY_RESULTS_PDF_FILE_LIST,
    REGION_DEFAULT_SELECTION,
    COUNTRY_DEFAULT_SELECTION,
    PRACTICE_DEFAULT_SELECTION,
    HISTORICAL_DEFAULT_SELECTION,
    FIRST_HISTORICAL_YEAR,
    SURVEY_TITLE_TEXT_NO_CULPEPPER_PRELIM,
    SURVEY_TITLE_TEXT_NO_CULPEPPER_FINAL,
    SURVEY_AVAIL_COUNTRY_NUMBER_LIST,
    SURVEY_RESULTS_EXCEL_FILE_LIST,
    SURVEY_RESULT_PDF_FILE_TEXT_TITLE,
    SURVEY_RESULT_EXCEL_FILE_TEXT_TITLE,
    NEXT_SURVEY_NAME_LIST,
    NEXT_SURVEY_OPEN_DATES,
    CURRENT_FINAL_RESULTS_SURVEY_LIST,
    FINAL_RESULTS_AVAILABLE_DATE,
    SURVEY_QUESTIONNAIRE_FILE_LIST,
    SURVEY_QUESTIONNAIRE_PDF_FILE_TEXT_TITLE,
    DEFINITIONS_DEFAULT_SELECTION,
    SURVEY_YEAR_2023_2024,
    SURVEY_YEAR_2023_2024_PRELIM,
    SURVEY_RESULT_WORD_FILE_TEXT_TITLE,
    SURVEY_RESULTS_WORD_FILE_LIST,
    SBS_DEV_PAGE_ADDRESS,
    SBS_LOCAL_DEV_PAGE_ADDRESS,
    SURVEY_YEAR_2024_PRELIM,
    SURVEY_YEAR_2024,
    SURVEY_YEAR_2024_2025_PRELIM,
    SURVEY_YEAR_2024_2025,
    SURVEY_YEAR_2023_PRELIM,
    SURVEY_YEAR_2023,
    EXCEL_TABLE_AVAILABLE_SURVEYS,
    DATA_COLLECTION_PERIOD_AVAILABLE_SURVEYS,
    MOST_RECENT_DATA_COLLECTION_PERIOD_AVAILABLE_SURVEYS,
    FINAL_REPORT_AVAILABLE_SURVEYS,
    NEXT_SURVEY_PARTICIPATION_LINKS,
    SURVEY_YEAR_2025_PRELIM,
    SURVEY_YEAR_2025,
    SURVEY_YEAR_2025_2026_PRELIM,
    SURVEY_YEAR_2025_2026,
    SURVEY_YEAR_2026_PRELIM,
    SURVEY_YEAR_2026,
    SURVEY_YEAR_2026_2027_PRELIM,
    SURVEY_YEAR_2026_2027,
    SURVEY_YEAR_2027_PRELIM,
    PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE,
    PRELIM_SURVEY_LIST_WITH_EFFECTIVE_DATE,
    DEFAULT_TO_PROJECTED_YEAR_SURVEY_LIST,
    SURVEY_DEFAULT_CUTOFFDATE_LIST,
    INDUSTRY_SECTOR_LABEL_SURVEY_LIST,
} from '../constants/constants'
import { REACT_APP_PAGE_ADDRESS } from '../config'

function Home() {
    const params = useParams()
    const surveyUUID = params.survey
    const survey = SURVEY_UUID_LIST[surveyUUID]
    const year = DEFAULT_TO_PROJECTED_YEAR_SURVEY_LIST.includes(survey)
        ? 'Projected'
        : 'Actual'
    const cutoffDate = SURVEY_DEFAULT_CUTOFFDATE_LIST[survey]

    const regionTopics = (
        <div>
            <p className="text-regular-indented">
                <ul className="nonlist-with-link">
                    <Link
                        className="link-padding text-decoration-underline"
                        to={`/${params.survey}${REGION_DEFAULT_SELECTION}&year=${year}&cutoffDate=${cutoffDate}`}
                    >
                        <strong>
                            Global Overview of Base Salary Increases
                        </strong>
                    </Link>
                </ul>
            </p>
        </div>
    )

    const countryTopics = (
        <div>
            <p className="text-regular-indented">
                {PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE.includes(survey) ? (
                    <span>Country Breakouts will include:</span>
                ) : (
                    <ul className="nonlist-with-link">
                        <Link
                            className="link-padding text-decoration-underline"
                            to={`/${params.survey}${COUNTRY_DEFAULT_SELECTION}&year=${year}&cutoffDate=${cutoffDate}`}
                        >
                            <strong>Country Breakout Reports</strong>
                        </Link>
                    </ul>
                )}
            </p>
            {[SURVEY_YEAR_2023_2024, SURVEY_YEAR_2023_2024_PRELIM].includes(
                survey
            ) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        {INDUSTRY_SECTOR_LABEL_SURVEY_LIST.includes(survey)
                            ? 'Salary Increases by Industry Sector and Vertical'
                            : 'Salary Increases by Industry Sector & Specialty'}
                    </li>
                    <li className="individual-link">
                        Salary Increases by Ownership Type
                    </li>
                    <li className="individual-link">
                        ds Salary Increases by Headcount
                    </li>
                    <li className="individual-link">
                        Salary Increases by Geographic Locale
                    </li>
                    <li className="individual-link">
                        Salary Increases by Geographic Pay Zone
                    </li>
                    <li className="individual-link">
                        Salary Increases by Job Function
                    </li>
                    <li className="individual-link">
                        Salary Increases by Job Level
                    </li>
                    <li className="individual-link">
                        Salary Increases by Performance
                    </li>
                    <li className="individual-link">
                        Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Promotional Base Pay Increases
                    </li>
                </ul>
            ) : [SURVEY_YEAR_2024_PRELIM, SURVEY_YEAR_2024].includes(survey) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        {INDUSTRY_SECTOR_LABEL_SURVEY_LIST.includes(survey)
                            ? 'Salary Increases by Industry Sector and Vertical'
                            : 'Salary Increases by Industry Sector & Specialty'}
                    </li>
                    <li className="individual-link">
                        Salary Increases by Ownership Type
                    </li>
                    <li className="individual-link">
                        Salary Increases by Headcount
                    </li>
                    <li className="individual-link">
                        Salary Increases by Geographic Locale
                    </li>
                    <li className="individual-link">
                        Salary Increases by Geographic Pay Zone
                    </li>
                    <li className="individual-link">
                        Salary Increases by Job Level
                    </li>
                    <li className="individual-link">
                        Salary Increases by Job Function
                    </li>
                    <li className="individual-link">
                        Salary Increases by Performance
                    </li>
                    <li className="individual-link">
                        Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Promotional Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Short-Term Cash Incentive Budgets
                    </li>
                </ul>
            ) : [
                  SURVEY_YEAR_2024_2025_PRELIM,
                  SURVEY_YEAR_2024_2025,
                  SURVEY_YEAR_2025_PRELIM,
                  SURVEY_YEAR_2025,
                  SURVEY_YEAR_2025_2026_PRELIM,
                  SURVEY_YEAR_2025_2026,
                  SURVEY_YEAR_2026_PRELIM,
                  SURVEY_YEAR_2026,
                  SURVEY_YEAR_2026_2027_PRELIM,
                  SURVEY_YEAR_2026_2027,
                  SURVEY_YEAR_2027_PRELIM,
              ].includes(survey) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        {INDUSTRY_SECTOR_LABEL_SURVEY_LIST.includes(survey)
                            ? 'Salary Increases by Industry Sector and Vertical'
                            : 'Salary Increases by Industry Sector & Specialty'}
                    </li>
                    <li className="individual-link">
                        Salary Increases by Ownership Type
                    </li>
                    <li className="individual-link">
                        Salary Increases by Headcount
                    </li>
                    <li className="individual-link">
                        Salary Increases by Geographic Locale
                    </li>
                    <li className="individual-link">
                        Salary Increases by Geographic Pay Zone
                    </li>
                    <li className="individual-link">
                        Salary Increases by Job Level and Function
                    </li>
                    <li className="individual-link">
                        Salary Increases by Performance
                    </li>
                    <li className="individual-link">
                        Salary Increases by Position-in-Range
                    </li>
                    <li className="individual-link">
                        Salary Increases by Compa-Ratio
                    </li>
                    <li className="individual-link">
                        Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Promotional Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Short-Term Cash Incentive Budgets
                    </li>
                </ul>
            ) : (
                <ul className="list-with-link">
                    <li className="individual-link">
                        {INDUSTRY_SECTOR_LABEL_SURVEY_LIST.includes(survey)
                            ? 'Salary Increases by Industry Sector and Vertical'
                            : 'Salary Increases by Industry Sector & Specialty'}
                    </li>
                    <li className="individual-link">
                        Salary Increases by Ownership Type
                    </li>
                    <li className="individual-link">
                        Salary Increases by Headcount
                    </li>
                    <li className="individual-link">
                        Salary Increases by Geographic Locale
                    </li>
                    <li className="individual-link">
                        Salary Increases by Geographic Pay Zone
                    </li>
                    <li className="individual-link">
                        Salary Increases by Job Level and Function
                    </li>
                    <li className="individual-link">
                        Salary Increases by Performance
                    </li>
                    <li className="individual-link">
                        Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Promotional Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Short-Term Cash Incentive Budgets
                    </li>
                </ul>
            )}
        </div>
    )
    const practiceTopics = (
        <div>
            <p className="text-regular-indented">
                {PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE.includes(survey) ? (
                    <span>Practices Reports will cover:</span>
                ) : (
                    <ul className="nonlist-with-link">
                        <Link
                            className="link-padding text-decoration-underline"
                            to={`/${params.survey}${PRACTICE_DEFAULT_SELECTION[survey]}&cutoffDate=${cutoffDate}`}
                        >
                            <strong>Practices Reports</strong>
                        </Link>
                    </ul>
                )}
            </p>
            {[SURVEY_YEAR_2026_2027, SURVEY_YEAR_2027_PRELIM].includes(
                survey
            ) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        <strong>
                            Use of Artificial Intelligence in Salary Budgeting
                            and Compensation Planning
                        </strong>
                        <ul>
                            <li>Prevalence of AI</li>
                            <li>Use Cases for AI</li>
                            <li>Reasons for Not Using AI</li>
                            {survey === SURVEY_YEAR_2026_2027 && (
                                <li>Plans for Using AI</li>
                            )}
                        </ul>
                    </li>
                    <li className="individual-link">
                        <strong>Base Pay Increases</strong>
                        <ul>
                            <li>Frequency of Base Pay Increases</li>
                            <li>
                                Factors Used to Determine Base Pay Increases
                            </li>
                        </ul>
                    </li>
                    <li className="individual-link">
                        <strong>Salary Structures</strong>
                        <ul>
                            <li>Prevalence of Salary Structures</li>
                            <li>Frequency of Salary Structure Adjustments</li>
                        </ul>
                    </li>
                    <li className="individual-link">
                        <strong>Short-Term Cash Incentives</strong>
                        <ul>
                            <li>Prevalence of Short-Term Cash Incentives</li>
                            <li>Types of Short-Term Cash Incentives</li>
                        </ul>
                    </li>
                    <li className="individual-link">
                        <strong>Long-Term Incentives</strong>
                        <ul>
                            <li>Prevalence of Long-Term Incentives</li>
                            <li>Types of Long-Term Incentives</li>
                        </ul>
                    </li>
                </ul>
            ) : [SURVEY_YEAR_2026_2027_PRELIM].includes(survey) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        Use of AI in Salary Budgeting and Compensation Planning
                    </li>
                    <li className="individual-link">
                        Frequency of Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Factors Used to Determine Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Prevalence of Salary Structures
                    </li>
                    <li className="individual-link">
                        Frequency of Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Prevalence of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Types of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Prevalence of Long-Term Incentives
                    </li>
                    <li className="individual-link">
                        Types of Long-Term Incentives
                    </li>
                </ul>
            ) : [SURVEY_YEAR_2026_PRELIM, SURVEY_YEAR_2026].includes(survey) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        Impact of Tariffs on Salary Increase Budgets
                    </li>
                    <li className="individual-link">
                        Frequency of Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Factors Used to Determine Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Prevalence of Salary Structures
                    </li>
                    <li className="individual-link">
                        Frequency of Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Prevalence of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Types of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Prevalence of Long-Term Incentives
                    </li>
                    <li className="individual-link">
                        Types of Long-Term Incentives
                    </li>
                </ul>
            ) : [SURVEY_YEAR_2025_2026_PRELIM, SURVEY_YEAR_2025_2026].includes(
                  survey
              ) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        Impact of Tariffs and Inflation on Salary Increase
                        Budgets
                    </li>
                    <li className="individual-link">
                        Frequency of Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Factors Used to Determine Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Prevalence of Salary Structures
                    </li>
                    <li className="individual-link">
                        Frequency of Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Prevalence of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Types of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Prevalence of Long-Term Incentives
                    </li>
                    <li className="individual-link">
                        Types of Long-Term Incentives
                    </li>
                </ul>
            ) : [
                  SURVEY_YEAR_2024_2025_PRELIM,
                  SURVEY_YEAR_2024_2025,
                  SURVEY_YEAR_2025_PRELIM,
                  SURVEY_YEAR_2025,
              ].includes(survey) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        Frequency of Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Factors Used to Determine Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Prevalence of Salary Structures
                    </li>
                    <li className="individual-link">
                        Frequency of Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Prevalence of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Types of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Prevalence of Long-Term Incentives
                    </li>
                    <li className="individual-link">
                        Types of Long-Term Incentives
                    </li>
                </ul>
            ) : [
                  SURVEY_YEAR_2023_2024,
                  SURVEY_YEAR_2023_2024_PRELIM,
                  SURVEY_YEAR_2024_PRELIM,
                  SURVEY_YEAR_2024,
              ].includes(survey) ? (
                <ul className="list-with-link">
                    <li className="individual-link">
                        Frequency of Base Salary Reviews
                    </li>
                    <li className="individual-link">
                        Prevalence of Salary Structures
                    </li>
                    <li className="individual-link">
                        Frequency of Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Prevalence of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Types of Short-Term Cash Incentives
                    </li>
                    <li className="individual-link">
                        Prevalence of Long-Term Incentives
                    </li>
                    <li className="individual-link">
                        Types of Long-Term Incentives
                    </li>
                </ul>
            ) : [SURVEY_YEAR_2023_PRELIM, SURVEY_YEAR_2023].includes(survey) ? (
                <ul className="list-with-link">
                    <li className="individual-link">Base Pay Philosophy</li>
                    <li className="individual-link">
                        Frequency of Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Prevalence of Salary Structures
                    </li>
                    <li className="individual-link">
                        Frequency of Salary Structure Adjustments
                    </li>
                    <li className="individual-link">
                        Salary Budgets by Geographic Location
                    </li>
                    <li className="individual-link">
                        Types of Base Pay Increases
                    </li>
                    <li className="individual-link">
                        Impact of Inflation on the Timing of Salary Increases
                    </li>
                    <li className="individual-link">
                        Other Compensation Plans & Practices
                    </li>
                </ul>
            ) : null}
        </div>
    )
    const participants = (
        <div>
            {' '}
            <p className="text-regular-indented">
                <ul className="nonlist-with-link">
                    <Link
                        className="link-padding text-decoration-underline"
                        to={'/' + params.survey + '/participants'}
                    >
                        <strong>List of Participants</strong>
                    </Link>
                </ul>
            </p>
        </div>
    )
    const historicalData = (
        <div>
            <p className="text-regular-indented">
                <ul className="nonlist-with-link">
                    <Link
                        className="link-padding text-decoration-underline"
                        to={'/' + params.survey + HISTORICAL_DEFAULT_SELECTION}
                    >
                        <strong>
                            Historical Base Salary Increases by Year (
                            {FIRST_HISTORICAL_YEAR} - {''}
                            {
                                SURVEY_YEAR_FOR_LAST_AVAILABLE_HISTORICAL_YEAR[
                                    survey
                                ]
                            }
                            )
                        </strong>
                    </Link>
                </ul>
            </p>
        </div>
    )

    const resultsFile = (
        <div>
            <p className="text-regular-indented">
                {FINAL_REPORT_AVAILABLE_SURVEYS.includes(survey) ? (
                    <>
                        {[
                            SBS_LOCAL_DEV_PAGE_ADDRESS.replace(/\/$/, ''),
                            SBS_DEV_PAGE_ADDRESS.replace(/\/$/, ''),
                        ].includes(
                            REACT_APP_PAGE_ADDRESS.replace(/\/$/, '')
                        ) ? (
                            <ul className="nonlist-with-link">
                                <a
                                    className="link-padding text-decoration-underline"
                                    href={require('../files/' +
                                        SURVEY_RESULTS_WORD_FILE_LIST[survey])}
                                    download={
                                        SURVEY_RESULTS_WORD_FILE_LIST[survey]
                                    }
                                >
                                    <strong>
                                        {SURVEY_RESULT_WORD_FILE_TEXT_TITLE}{' '}
                                    </strong>
                                </a>
                                <img
                                    className="survey-file-images"
                                    alt="WORD"
                                    border="0"
                                    src={require('../imgs/docx_icon.svg.png')}
                                ></img>
                            </ul>
                        ) : null}

                        <ul className="nonlist-with-link">
                            <a
                                className="link-padding text-decoration-underline"
                                href={require('../files/' +
                                    SURVEY_RESULTS_PDF_FILE_LIST[survey])}
                                download={SURVEY_RESULTS_PDF_FILE_LIST[survey]}
                            >
                                <strong>
                                    {SURVEY_RESULT_PDF_FILE_TEXT_TITLE}{' '}
                                </strong>
                            </a>
                            <img
                                className="survey-file-images"
                                alt="PDF"
                                border="0"
                                src={PdfIcon}
                            ></img>
                        </ul>
                    </>
                ) : null}
                {EXCEL_TABLE_AVAILABLE_SURVEYS.includes(survey) ? (
                    <div>
                        <ul className="nonlist-with-link">
                            <a
                                className="link-padding text-decoration-underline"
                                href={require('../files/' +
                                    SURVEY_RESULTS_EXCEL_FILE_LIST[survey])}
                                download={
                                    SURVEY_RESULTS_EXCEL_FILE_LIST[survey]
                                }
                            >
                                {SURVEY_RESULT_EXCEL_FILE_TEXT_TITLE}{' '}
                            </a>
                            <img
                                className="survey-file-images"
                                alt="Excel"
                                border="0"
                                src={ExcelIcon}
                            ></img>
                        </ul>
                    </div>
                ) : null}
            </p>
        </div>
    )

    const questionnaireFile = (
        <div>
            <p className="text-regular-indented">
                <ul className="nonlist-with-link">
                    <a
                        className="link-padding text-decoration-underline"
                        href={require('../files/' +
                            SURVEY_QUESTIONNAIRE_FILE_LIST[survey])}
                        download={SURVEY_QUESTIONNAIRE_FILE_LIST[survey]}
                    >
                        <strong>
                            {SURVEY_QUESTIONNAIRE_PDF_FILE_TEXT_TITLE}{' '}
                        </strong>
                    </a>
                    <img
                        className="survey-file-images"
                        alt="PDF"
                        border="0"
                        src={PdfIcon}
                    ></img>
                </ul>
            </p>
        </div>
    )

    const definitions = (
        <div>
            <p className="text-regular-indented">
                <ul className="nonlist-with-link">
                    <Link
                        className="link-padding text-decoration-underline"
                        to={'/' + params.survey + DEFINITIONS_DEFAULT_SELECTION}
                    >
                        <strong>Definitions</strong>
                    </Link>
                </ul>
            </p>
        </div>
    )

    const OpenedNextSurvey = (
        <div>
            <p className="text-bold">
                <span>
                    {NEXT_SURVEY_NAME_LIST[survey]} Salary Budget Survey
                </span>
            </p>
            <p className="text-regular">
                <span className="text-regular-only">
                    The {NEXT_SURVEY_NAME_LIST[survey]} Salary Budget &amp;
                    Compensation Planning Survey is&nbsp;
                </span>
                <a
                    href={NEXT_SURVEY_PARTICIPATION_LINKS[survey]}
                    style={{ textDecoration: 'underline' }}
                >
                    open for participation.
                </a>
            </p>
        </div>
    )

    const UnopenedNextSurvey = (
        <div>
            <p className="text-bold">
                <span>
                    {NEXT_SURVEY_NAME_LIST[survey]} Salary Budget Survey
                </span>
            </p>
            <p className="text-regular">
                <span className="text-regular-only">
                    The {NEXT_SURVEY_NAME_LIST[survey]} Salary Budget &amp;
                    Compensation Planning Survey will be open for participation
                    {NEXT_SURVEY_OPEN_DATES[survey]}.
                </span>
            </p>
        </div>
    )
    return (
        <div className="d-flex justify-content-between ">
            <div className="flex-fill empty-space"></div>
            <div className="home-page-main">
                <div className="text-section-title">
                    {PRELIM_SURVEY_LIST.includes(survey) ? (
                        <h4>
                            {SURVEY_YEAR_NAME_LIST[survey]}{' '}
                            {SURVEY_TITLE_TEXT_NO_CULPEPPER_PRELIM}
                        </h4>
                    ) : (
                        <h4>
                            {SURVEY_YEAR_NAME_LIST[survey]}{' '}
                            {SURVEY_TITLE_TEXT_NO_CULPEPPER_FINAL}
                        </h4>
                    )}
                </div>
                <div className="text-section">
                    {/*show text different for current survey results based on if there is a list survey and if it is a prelim results*/}
                    <p className="text-bold">
                        {PRELIM_SURVEY_LIST.includes(survey) ? (
                            <span>Preliminary Survey Results</span>
                        ) : (
                            <span></span>
                        )}{' '}
                        {PRELIM_SURVEY_LIST.includes(survey) && (
                            <em className="home-page-publish-dates">
                                (
                                {PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE.includes(
                                    survey
                                )
                                    ? 'published'
                                    : 'effective'}{' '}
                                {SURVEY_PUBLISH_DATE_LIST[survey]})
                            </em>
                        )}
                    </p>
                    {/*show text differnet based on if it is a prelim results or final results*/}
                    {PRELIM_SURVEY_LIST.includes(survey) ? (
                        <div
                            className="text-regular-indented"
                            style={{ maxWidth: '800px', lineHeight: '1.6' }}
                        >
                            <p>
                                {PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE.includes(
                                    survey
                                ) && (
                                    <>
                                        Preliminary high-level results include
                                        data collected from{' '}
                                        {SURVEY_ORG_NUMBER_LIST[
                                            survey
                                        ].toLocaleString()}{' '}
                                        companies{' '}
                                        {PRELIM_SURVEY_LIST_WITHOUT_START_DATE.includes(
                                            survey
                                        )
                                            ? `through ${SURVEY_MOST_RECENT_SUBMISSION_DATE[survey]}.`
                                            : `between ${SURVEY_OLDEST_SUBMISSION_DATE[survey]} and ${SURVEY_MOST_RECENT_SUBMISSION_DATE[survey]}.`}
                                    </>
                                )}
                                {/* {PRELIM_SURVEY_LIST_WITH_EFFECTIVE_DATE.includes(
                                    survey
                                ) && (
                                    <p>
                                        Preliminary results include a rolling
                                        annual dataset, with an option to view
                                        data from the most recent time periods.
                                    </p>
                                )} */}
                            </p>
                        </div>
                    ) : (
                        <p className="text-regular-indented-home-page">
                            <p>
                                <p style={{ marginBottom: '8px' }}>
                                    <span className="new-line">
                                        <span className="text-bold-only">
                                            Publication Date:{' '}
                                        </span>
                                        <span className="text-regular-only">
                                            {SURVEY_PUBLISH_DATE_LIST[survey]}{' '}
                                        </span>
                                    </span>
                                </p>
                                {[
                                    SURVEY_YEAR_2023,
                                    SURVEY_YEAR_2023_2024,
                                    SURVEY_YEAR_2024,
                                    SURVEY_YEAR_2024_2025,
                                    SURVEY_YEAR_2025,
                                ].includes(survey) ? (
                                    <span className="new-line">
                                        <span className="text-bold-only">
                                            Survey Dates:{' '}
                                        </span>

                                        <span className="text-regular-only">
                                            {
                                                SURVEY_OLDEST_SUBMISSION_DATE[
                                                    survey
                                                ]
                                            }{' '}
                                            through{' '}
                                            {
                                                SURVEY_MOST_RECENT_SUBMISSION_DATE[
                                                    survey
                                                ]
                                            }
                                        </span>
                                    </span>
                                ) : null}
                                <p style={{ marginBottom: '8px' }}>
                                    {DATA_COLLECTION_PERIOD_AVAILABLE_SURVEYS.includes(
                                        survey
                                    ) ? (
                                        <span className="new-line">
                                            {MOST_RECENT_DATA_COLLECTION_PERIOD_AVAILABLE_SURVEYS.includes(
                                                survey
                                            ) ? (
                                                <span className="text-bold-only">
                                                    Most Recent Data Collection
                                                    Period:{' '}
                                                </span>
                                            ) : (
                                                <span className="text-bold-only">
                                                    Data Collection Period:{' '}
                                                </span>
                                            )}
                                            <span className="text-regular-only">
                                                {
                                                    SURVEY_OLDEST_SUBMISSION_DATE[
                                                        survey
                                                    ]
                                                }{' '}
                                                through{' '}
                                                {
                                                    SURVEY_MOST_RECENT_SUBMISSION_DATE[
                                                        survey
                                                    ]
                                                }
                                            </span>
                                            {MOST_RECENT_DATA_COLLECTION_PERIOD_AVAILABLE_SURVEYS.includes(
                                                survey
                                            ) ? (
                                                <span className="text-regular-only">
                                                    . Reports provide filters to
                                                    view data by additional
                                                    periods of time.
                                                </span>
                                            ) : (
                                                <span className="text-regular-only">
                                                    {' '}
                                                    (trailing annual period).
                                                    Reports provide filters to
                                                    view data by more recent
                                                    periods.
                                                </span>
                                            )}
                                        </span>
                                    ) : null}
                                </p>
                                <p style={{ marginBottom: '8px' }}>
                                    <span className="new-line">
                                        <span className="text-bold-only">
                                            Participants:{' '}
                                        </span>
                                        <span className="text-regular-only">
                                            {SURVEY_ORG_NUMBER_LIST[
                                                survey
                                            ].toLocaleString()}{' '}
                                            participating organizations
                                            reporting data for employees across{' '}
                                            {
                                                SURVEY_AVAIL_COUNTRY_NUMBER_LIST[
                                                    survey
                                                ]
                                            }{' '}
                                            countries and territories.
                                        </span>
                                    </span>
                                </p>
                            </p>
                        </p>
                    )}
                    {/*PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE will show the 'View preliminary high-level results' link*/}
                    {PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE.includes(survey) ? (
                        <div>
                            <div>
                                <ul className="prelim-nonlist-with-link">
                                    <Link
                                        className="link-padding text-decoration-underline"
                                        to={`/${params.survey}${REGION_DEFAULT_SELECTION}&year=${year}`}
                                    >
                                        <strong>
                                            View preliminary high-level results
                                        </strong>
                                    </Link>
                                </ul>
                            </div>
                        </div>
                    ) : null}

                    {/* PRELIM_SURVEY_LIST_WITH_EFFECTIVE_DATE will show the 'Global Overview, Country Breakouts, Practices, and Historical' link */}
                    {PRELIM_SURVEY_LIST_WITH_EFFECTIVE_DATE.includes(survey) ? (
                        <div>
                            {regionTopics}
                            {countryTopics}
                            {practiceTopics}
                            {historicalData}
                        </div>
                    ) : null}
                    {/* show the final survey results description section if it is a prelim survey */}
                    {PRELIM_SURVEY_LIST.includes(survey) ? (
                        <div>
                            <div>
                                <p className="text-bold">
                                    Final Survey Results{' '}
                                    <em className="home-page-publish-dates">
                                        (available by{' '}
                                        {FINAL_RESULTS_AVAILABLE_DATE[survey]})
                                    </em>
                                </p>
                                <p className="text-regular-indented">
                                    <p>
                                        Final comprehensive results will include
                                        new and refreshed data from
                                        participating companies.
                                    </p>
                                </p>
                            </div>
                        </div>
                    ) : null}
                    {PRELIM_SURVEY_LIST.includes(survey) ? null : (
                        <div>{regionTopics}</div>
                    )}

                    {/* for prelim_survey_with_effective_date, the countryTopics and practiceTopics have been shown before the 'final results' section */}
                    {!PRELIM_SURVEY_LIST_WITH_EFFECTIVE_DATE.includes(
                        survey
                    ) ? (
                        <div>
                            {countryTopics}
                            {practiceTopics}
                        </div>
                    ) : null}
                    {PRELIM_SURVEY_LIST.includes(survey) ? (
                        <div className="prelim-site-space-holder"></div>
                    ) : (
                        <div></div>
                    )}
                    {PRELIM_SURVEY_LIST.includes(survey) ? (
                        <div></div>
                    ) : (
                        <div>
                            {historicalData}
                            {resultsFile}
                            {questionnaireFile}
                            {participants}
                            {definitions}

                            {CURRENT_FINAL_RESULTS_SURVEY_LIST.includes(
                                survey
                            ) ? (
                                <div className="next-survey-section">
                                    <hr></hr>
                                    <div className="next-survey-div">
                                        {/* {OpenedNextSurvey} */}
                                        {UnopenedNextSurvey}
                                    </div>
                                </div>
                            ) : (
                                <div className="next-survey-div"></div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div className="flex-fill empty-space "></div>
        </div>
    )
}

export default Home
